<template>
  <v-app id="stm_app">
    <v-app-bar
      app
      color="primary"
      dark
      class="no-print"
    >
      <div class="d-flex align-center">
        <img
          alt="Source Too Machine Logo"
          class="shrink mr-2"
          :src="logo"
          width="40"
        />
        Source Too Machine
      </div>
      <v-spacer />
      <v-btn 
        v-if="isLoggedIn"
        @click="logMeOut"
        class="no-print"
      >
        Logout
      </v-btn>
    </v-app-bar>
    
    <!-- PWA Install Dialog -->
    <v-dialog
      v-model="pwaDialog"
      max-width="400"
      persistent
    >
      <v-card>
        <v-card-title>
          <v-icon left color="primary">mdi-cellphone-arrow-down</v-icon>
          Install App
        </v-card-title>
        <v-card-text>
          <p v-if="!isIphoneDevice">Install Source Too Machine as an app on your device for quick access and offline functionality!</p>
          <p v-else>To install Source Too Machine on your iPhone or iPad, tap the Share button in Safari and select "Add to Home Screen".</p>
        </v-card-text>
        <v-card-actions>
          <v-btn
            text
            @click="dismissPWADialog"
          >
            Ignore
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            v-if="!isIphoneDevice"
            color="primary"
            @click="installPWA"
            :loading="installingPWA"
          >
            Install
          </v-btn>
          <v-btn v-else
            color="primary"
            @click="() => pwaDialog = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    
    <v-main>
      
      <home />
    </v-main>
  </v-app>
</template>

<script>
import appMixin from '@/mixins/app.mixin'

export default {
  name: 'App',

  mixins: [appMixin]
};

</script>

<style lang="scss">
  .wp-block-template-part,
  .wp-block-template-part,
  .wp-block-post-title, 
  main > .wp-block-group {
    display:none !important;
  }

  .wp-block-post-content, #stm_app {
      margin: 0px !important;
      padding: 0px !important;
  }
  
  #stm_app {
    padding: 10px;
    max-width: 100%;

  .v-data-table__wrapper {
    margin: 10px;
    height: 60vh !important;
    overflow: scroll !important;

    td, th {
      white-space: normal;
    }
  }

    .print-btn {
      position: absolute;
      top: 0px;
      right: 10px;
    }

    .text-start {
      max-width: 500px !important;
      white-space: pre-wrap !important;
    }

    .v-data-table__mobile-table-row {
      border: 1px solid lightgray !important;
      border-radius: 10px !important;
      margin: 5px 0 !important;
    }

    .v-tabs-bar__content {
      margin-bottom: 10px !important;
    }

    .required {
      .v-text-field__prefix {
        color: red !important;
      }
    }
  }

@media (max-width: 661px) {
    #masterBoard table {
        display: flex;
        flex-direction: column;
    }
    
    td.v-data-table__mobile-row:first-child {
        justify-content: flex-start;
    }    
}

@media print {
  body {
    margin: 0;
    padding: 0;
  }

  .v-application--wrap {
    min-height: 95vh !important;
  }

  #stm_app {
    .v-main {
      padding-top: 0px !important;
    }

    .no-print, .v-data-footer, .v-icon.mdi {
      display: none;
    }

    .printable {
      height: auto !important;
      overflow: visible !important;
      margin: 0px !important;
      transform: scale(0.95);
      transform-origin: top;
      page-break-inside: avoid;

      .text-start {
        width:5%;
        max-width:5%;
        min-width:5%;
        word-wrap: break-word !important;
        white-space: normal !important;
      }

      .text-start:nth-last-child(-n+3) {
        max-width: 20%;
      }
    }
  }
}
</style>